"use client";

import { useEffect, useState } from "react";

export const useMountTransition = ({
  isMounted,
  mountDelay = 200,
  unmountDelay = 300,
}) => {
  const [isTransitioning, setIsTransitioning] = useState(isMounted);

  useEffect(() => {
    let timeoutId;

    if (isMounted && !isTransitioning) {
      setTimeout(() => setIsTransitioning(true), mountDelay);
    } else if (!isMounted && isTransitioning) {
      timeoutId = setTimeout(() => setIsTransitioning(false), unmountDelay);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [mountDelay, unmountDelay, isMounted, isTransitioning]);

  return isTransitioning;
};
